"use client";

import { useEffect, useState } from "react";

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
} from "@/components/ui/dropdown-menu";

import globe from "@/public/earth-globe-modern.svg";
import whiteglobe from "@/public/earth-globe-white.svg";
import Image from "next/image";
import { Check, ChevronDown } from "lucide-react";
import { Paragraph } from "@/components/ui/typography";
import { getCookieValue, setCookieValue } from "@/app/utils/utility";

const langauges = [
  { value: "en", name: "English" },
  { value: "fr", name: "French" },
  { value: "es", name: "Spanish" },
  { value: "ar", name: "Arabic" },
];

export default function LangaugeDropDown({
  variant = "primary",
  collapsed = true,
}) {
  const [selectedMenu, setSelectedMenu] = useState(
    getCookieValue("selectedLanguage") || "en"
  );

  const [open, setOpen] = useState(false);

  // Effect to update the selected language when the cookie changes
  useEffect(() => {
    const handleCookieChange = () => {
      const newLanguage = getCookieValue("selectedLanguage") || "en";
      setSelectedMenu(newLanguage);
    };

    // Listen for the 'storage' event to sync language changes across tabs or instances
    window.addEventListener("storage", handleCookieChange);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("storage", handleCookieChange);
    };
  }, []);

  return (
    <>
      <DropdownMenu onOpenChange={setOpen}>
        <DropdownMenuTrigger className="" asChild>
          <div className="flex items-center gap-2 focus:ring-0 focus:outline-none w-[85px] pl-[6px]">
            <Image
              src={variant === "primary" ? globe : whiteglobe}
              alt="globe"
              width={24}
              height={24}
              className="h-[24px] w-[24px] "
            />{" "}
            <div
              className={`flex  !text-midnightIndigo-400 mt-1 ${
                collapsed && variant == "primary" ? "md:hidden" : "md:flex"
              }  lg:flex`}
            >
              <span
                className={`uppercase  ${
                  variant === "primary" ? "" : "text-white"
                }`}
              >
                {selectedMenu}
              </span>
              <ChevronDown
                className={`animate duration-300 h-[20px] w-[20px] ${
                  variant === "primary" ? "" : "text-white"
                } ${open ? "rotate-180" : "rotate-0"}`}
              />
            </div>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className={`z-[99999] p-0 ${
            variant === "primary"
              ? ""
              : "bg-system-graphite  ring-0 mt-0 border border-system-graphite"
          }`}
        >
          <DropdownMenuGroup className="">
            {langauges.map((item, index) => (
              <DropdownMenuItem
                key={index}
                onClick={() => {
                  setCookieValue("selectedLanguage", item.value);
                  setSelectedMenu(item.value);
                  window.dispatchEvent(new Event("storage")); //
                }}
                className={`flex justify-between cursor-pointer rounded-none py-[12px] h-[44px] w-[144px] p-[10px] ${
                  variant === "primary"
                    ? "hover:!bg-midnightIndigo-150 "
                    : "text-white bg-system-obsidian border-none  hover:!bg-midnightIndigo-500 hover:!text-white"
                } ${
                  selectedMenu === item.value
                    ? variant === "primary"
                      ? " bg-midnightIndigo-150 "
                      : "bg-midnightIndigo-500 border-none text-white"
                    : ""
                }`}
              >
                <Paragraph variant="regular">{item.name}</Paragraph>
                {selectedMenu === item.value && <Check className="w-5 h-5" />}
              </DropdownMenuItem>
            ))}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
